import { scrollProgress } from '../../animations/gsapAnimations'
import { useGsapContext } from '../../hooks/useGsapReveal'

/* One lime hairline along the very top of the viewport, growing with the
   page. Over the bar, under nothing: a page this long owes its visitor a
   reading of how far there is to go, and a scrollbar on a dark page is the
   one thing nobody looks at. Tied to the scroll rather than timed, so it
   is a measurement, not motion — it stays on under reduced motion too. */
function ScrollProgress() {
  const ref = useGsapContext<HTMLDivElement>((bar) => scrollProgress(bar))

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-60 h-0.5 origin-left scale-x-0 bg-lime shadow-[0_0_12px_rgb(200_245_66/0.7)]"
    />
  )
}

export default ScrollProgress
